<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="permissionsArray.includes('access_form_email_manager')">
            <div class="container-fluid xyz">
                <!--page content-->
                <div class="admin-page-content">
                    <div class="page-title-container">
                        <div class="page-name">{{pageTitle}}</div>
                        <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                    </div>
                    <!--Forms-->
                    <div class="forms-container default-bx-shadow responsive-forms-container">
                        <div class="row no-margin">
                            <!-- Form -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Form :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="formId" name="formId"
                                        label="text"
                                        @input="changeFormMaster"
                                        :options="formIdArr" :clearable=false placeholder="Select Form">
                                    </v-select>
                                    <div class="help is-danger">{{formIdError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <!-- <template v-if="!isLaborReviewRequest">
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label">Department :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <v-select v-model="departmentId" name="departmentId"
                                            label="text"
                                            @input="changedValueDepartment"
                                            :options="departmentArr" :clearable=false placeholder="Select Department">
                                        </v-select>
                                        <div class="help is-danger">{{departmentIdError}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                            </template> -->
                            <!-- Location -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Location :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <!-- <v-select v-model="location" name="location"
                                        label="name" placeholder="Select Location"
                                        @input="location_error = ''"
                                        :options="location_arr" :clearable=false>
                                    </v-select> -->
                                    <v-select v-model="location" name="location"
                                        multiple
                                        label="name"
                                        @input="location_error = ''"
                                        placeholder="Select Location"
                                        :options="location_arr" :clearable=false>
                                    </v-select>
                                    <div class="help is-danger">{{location_error}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <!-- To Email -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">To Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-tags-input
                                        v-model="toEmail"
                                        :tags="toEmailTagsArr"
                                        :validation="validation"
                                        @tags-changed="newTags => toEmailTagsArr = newTags"
                                        @before-adding-tag="checkToEmailTag"
                                        placeholder=""
                                    />
                                    <div class="help is-danger">{{toEmailError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <!-- CC Email -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">CC Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <!-- <input type="text" maxlength="190" class="form-control" v-model="ccEmail" id="ccEmail" placeholder="Enter CC Email" name="ccEmail"> -->
                                    <!--<input @input="emailError = ''" id="email" v-model="email" class="form-control" type="text"/>-->
                                    <vue-tags-input
                                        v-model="ccEmail"
                                        :tags="ccEmailTagsArr"
                                        :validation="validation"
                                        @tags-changed="newTags => ccEmailTagsArr = newTags"
                                        @before-adding-tag="checkCCEmailTag"
                                        placeholder=""
                                    />
                                    <div class="help is-danger">{{ccEmailError}}</div>
                                    <!-- <div class="requiredstar">*</div> -->
                                </div>
                            </div>
                            <template v-if="!isLaborReviewRequest">
                                <div class="col-6 forms-block">
                                </div>
                            </template>
                            <div class="clearfix"></div>
                            <div class="mr-17 pb-12 float-l">
                                <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                                <button v-if="edit_id == 0" type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addFormMapperData('save_and_continue')"><span id="saveAndContinueAttachment">Save And Continue</span></button>
                                <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addFormMapperData('save')"><span id="createAttachment">Save</span></button>
                            </div>

                        </div>
                    </div>
                    <!-- Forms -->
                </div>
                <!--page content-->
            </div>
        </template>
        <template v-else>
            <no-access></no-access>
        </template>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
    import VueTagsInput from '@johmun/vue-tags-input';
    import NoAccessPage from "@/components/NoAccessPage/NoAccessPage";

    var self;
    Vue.component('v-select', vSelect);
    Vue.component("app-footer", Footer);
    Vue.component('no-access', NoAccessPage);
    export default {
        name: 'AddUpdateFormEmailManager',
        mixins: [commonMixins],
        components: {
            VueTagsInput,
        },
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Add Form Email Manager',
                edit_id: 0,
                toEmail:"",
                ccEmail: "",
                toEmailTagsArr:[],
                ccEmailTagsArr: [],
                validation: [{
                    classes: 'valid-email',
                    rule: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                }],
                isValidToEmailTag :true,
                isValidCCEmailTag : true,
                toEmailError:"",
                ccEmailError: "",
                departmentArr: [ 
                    /* {
                        text: 'Body Shop',
                        value: 'Body Shop',
                    },
                    {
                        text: 'Service',
                        value: 'Service',
                    }, */
                ],
                departmentId: "",
                departmentIdError: "",
                location: [],
                location_arr: [],
                location_error: "",
                formId: "",
                formIdArr: [],
                formIdError: "",

                managerEmail: "",
                loginUserRoleId: 1,
                bodyShopLocationArr: [],
                serviceLocationArr: [],
                permissionsArray: ['access_form_email_manager'],
                laborReviewLocationArr: [],
                isLaborReviewRequest: false,
            }
        },
        watch: {
            /* location: function(location) {
                self.managerEmail = "";
                if (location != null || location.id) {
                    for(var index = 0;index<self.location_arr.length;index++) {
                        var obj = self.location_arr[index];
                        if(obj['id'] == location.id) {
                            self.managerEmail = obj['manager_email'];
                        }
                    }
                }
            }, */
            // formId: function(formId) {
            //     self.location_arr = [];
            //     self.isLaborReviewRequest = false;
            //     // self.changeFormValue(formId.value);
            //     if(formId.value == 6 || formId.value == 8) {
            //         self.departmentId = "";
            //         self.departmentIdError = "";
            //         self.isLaborReviewRequest = true;
            //         self.location_arr = self.laborReviewLocationArr;
            //     }
            // },
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.loadFormMasterData();
            self.menuActive("ListFormEmailManager");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
            }
            this.$nextTick(function () {
                if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                    self.edit_id = self.$route.params.id;
                    self.pageTitle = 'Edit Form Email Manager';
                    self.getFormMapperDataById();
                    $("#addAndContinueLocationBtn").hide();
                    $("#createAttachment").html("Update");
                }
            });
            self.loadLocationFromZone();
            // self.loadBodyShopLocation();
        },
        methods: {
            buttonBack() {
                self.$router.push('/form/email/manager/list');
            },
            changeFormValue: function (id) {
                /* if (id != null && id != "" && typeof id != "undefined") {
                    let idArray = [];
                    var editId = 0;
                    if (self.$route.params.id != null && self.$route.params.id != "" && typeof (self.$route.params.id) != "undefined") {
                        editId = self.$route.params.id;
                    }
                    for (let i = 0; i < id.length; i++) {
                        idArray.push(id[i].value)
                    }
                    var config = {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("token")
                        },
                        params: {
                            edit_id: editId,
                            form_key_id: id
                        }
                    };
                    HTTP.get('/formemailmanager/check', config)
                        .then(response => {
                            if (response.data.status == "Success") {
                                self.$swal({
                                    type : "error",
                                    text: response.data.message,
                                    confirmButtonColor: '#3085d6',
                                    confirmButtonText: 'Ok',
                                });
                            }
                        })
                        .catch(function (err) {
                            // console.log(err);
                            self.catchHandler(err, function () {});
                        });
                } */
            },
            checkToEmailTag: function(obj) {
                self.toEmailError = "";
                self.isValidToEmailTag = true;
                var tagEmail = JSON.stringify(obj.tag.text).split('"');
                if(!self.validEmail(tagEmail[1])) {
                    self.isValidToEmailTag = false;
                    self.toEmailError = "Please enter valid Email";
                } else obj.addTag();
            },
            checkCCEmailTag: function(obj) {
                self.ccEmailError = "";
                self.isValidCCEmailTag = true;
                var tagEmail = JSON.stringify(obj.tag.text).split('"');
                if(!self.validEmail(tagEmail[1])) {
                    self.isValidCCEmailTag = false;
                    self.ccEmailError = "Please enter valid Email";
                } else obj.addTag();
            },
            changedValueDepartment: function(department) {
                self.departmentIdError = "";
                self.location_arr = [];
                self.location = [];
                if(department != '' && department != null) {
                    if (department != 'undefined' && department.value) {
                        self.location_arr = self.serviceLocationArr;
                        for(var index = 0; index < self.location_arr.length; index++) {
                            var objLocation = self.location_arr[index];
                            if(objLocation['name'] == 'Connelly Springs, NC' || objLocation['id'] == 999) {
                                self.location_arr.splice(index, 1);
                            }
                        }
                        if(department.value == 'Body Shop') {
                            self.location_arr = self.bodyShopLocationArr;
                        }
                        if(department.value == 'Warranty') {
                            var objLoc = {
                                "name": "Connelly Springs, NC",
                                "id": 999,
                                "position": {
                                    "lat": 35.7429,
                                    "lng": -81.5134
                                },
                                "is_buswest": false,
                                "manager_email": "dbrant@vvgtruck.com",
                                "manager_name": "Deanne Brant"
                            };
                            self.location_arr.push(objLoc);
                            self.location_arr = self.location_arr.sort((a, b) => { return a.name.localeCompare(b.name);});
                        }
                    }
                }
            },
            getFormMapperDataById: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    params: {
                        id: self.edit_id,
                    }
                };
                self.showLoader();
                HTTP.get("/form/mapper/get", config)
                        .then(function (response) {
                            self.formId = {text: response.data.content.formName, value: response.data.content.form_id};
                            if(response.data.content.form_id == 6 || response.data.content.form_id == 8) {
                                self.isLaborReviewRequest = true;
                                self.departmentId = "";
                                self.departmentIdError = "";
                            } else {
                                self.isLaborReviewRequest = false;
                                setTimeout(function() {
                                    self.departmentId = {text: response.data.content.department, value: response.data.content.department};
                                }, 50);
                            }
                            setTimeout(function() {
                                self.location.push({"name": response.data.content.locationName, "id": response.data.content.location_id});
                                // self.location = response.data.content.locationArr;
                            }, 50);
                            if(response.data.content.cc_email && response.data.content.cc_email != 'NULL') {
                                var ccEmailArr = response.data.content.cc_email.split(",");
                                for(var index = 0; index < ccEmailArr.length; index++) {
                                    self.ccEmailTagsArr.push({"text": ccEmailArr[index], "tiClasses": ["ti-valid"]});
                                }
                            }
                            if(response.data.content.to_email && response.data.content.to_email != 'NULL') {
                                var toEmailArr = response.data.content.to_email.split(",");
                                for(var index = 0; index < toEmailArr.length; index++) {
                                    self.toEmailTagsArr.push({"text": toEmailArr[index], "tiClasses": ["ti-valid"]});
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            console.log(err);
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            loadFormMasterData: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                };
                HTTP.get("/form/manager/get", config)
                    .then(function (response) {
                        self.formIdArr = response.data.content;
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            changeFormMaster: function(formMaster) {
                if (formMaster != "") {
                    self.departmentId = "";
                    self.departmentArr = [];
                    var arrWitOuthWarrantyData = [
                        {
                            text: 'Body Shop',
                            value: 'Body Shop',
                        },
                        {
                            text: 'Service',
                            value: 'Service',
                        },
                    ];
                    self.departmentArr = arrWitOuthWarrantyData;
                    if(formMaster.value == 3) {
                        self.departmentArr = [];
                        var arrWithWarrantyData = [
                            {
                                text: 'Body Shop',
                                value: 'Body Shop',
                            },
                            {
                                text: 'Service',
                                value: 'Service',
                            },
                            {
                                text: 'Warranty',
                                value: 'Warranty',
                            },
                        ];
                        self.departmentArr = arrWithWarrantyData;
                    }
                }
                self.formIdArrError = "";
            },
            loadBodyShopLocation: function() {
                var config = {
                    params: {
                        slug: "vvg-au",
                        department_id: 8
                    }
                };
                HTTPGUZZLE.get("/api/v1/getlocations", config)
                    .then(function (response) {
                        self.bodyShopLocationArr = response.data.locations;
                        if(self.bodyShopLocationArr && self.bodyShopLocationArr.length > 0) {
                            /* for(var index = 0; index < self.bodyShopLocationArr.length; index++) {
                                var objLocation = self.bodyShopLocationArr[index];
                                if(objLocation['name'] == 'Hope Mills Bodyshop, NC' || objLocation['id'] == 76) {
                                    self.bodyShopLocationArr.splice(index, 1);
                                }
                            } */
                            self.bodyShopLocationArr = self.bodyShopLocationArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                        }
                        self.loadLocation();
                        // console.log(JSON.stringify(self.bodyShopLocationArr));
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            loadLocation: function() {
                var config = {
                    params: {
                        slug: "vvg-au",
                        department_id: 2
                    }
                };
                self.showLoader();
                HTTPGUZZLE.get("/api/v1/getlocations", config)
                        .then(function (response) {
                            self.location_arr = response.data.locations;


                            // self.serviceLocationArr = response.data.locations;
                            // self.serviceLocationArr = self.serviceLocationArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                            
                            // self.laborReviewLocationArr = self.bodyShopLocationArr.concat(self.serviceLocationArr);
                            // self.laborReviewLocationArr = self.laborReviewLocationArr.reduce((acc, current) => {
                            //     const x = acc.find(item => item.id === current.id);
                            //     if (!x) {
                            //         return acc.concat([current]);
                            //     } else {
                            //         return acc;
                            //     }
                            // }, []);
                            
                            // self.laborReviewLocationArr = self.laborReviewLocationArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                            
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            loadLocationFromZone() {
                var config = {
                    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
                    params: {
                        id: self.edit_id
                    }
                };
                self.showLoader();
                HTTP.get("/get/locations", config)
                    .then(function (response) {
                        self.location_arr = response.data.content;
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () { });
                    });
            },
            checkForm: function () {
                var checked = true;
                self.location_error = "";
                self.departmentIdError = "";
                self.toEmailError = "";
                self.ccEmailError = "";
                self.formIdError = "";
                self.isValidCCEmailTag = true;

                // if(!self.isLaborReviewRequest) {
                //     if (self.departmentId == null || !self.departmentId.value) {
                //         self.departmentIdError = "Select Department";
                //         if (checked) {
                //             checked = false;
                //         }
                //     }
                // }
                if (self.location.length == 0) {
                    self.location_error = "select Location";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.formId == null || !self.formId.value) {
                    self.formIdError = "select Form";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.toEmailTagsArr.length == 0) {
                    self.isValidToEmailTag = false;
                    self.toEmailError = "Please enter email";
                    if (checked) {
                        checked = false;
                    }
                }
                /* if (self.ccEmailTagsArr.length == 0) {
                    self.isValidCCEmailTag = false;
                    self.ccEmailError = "Please enter email";
                    if (checked) {
                        checked = false;
                    }
                } */
                return checked;
            },
            addFormMapperData(flag) {
                setTimeout(() => {
                    if (self.isValidCCEmailTag && self.isValidToEmailTag && self.checkForm()) {
                        var toEmailData = "";
                        if(self.toEmailTagsArr && self.toEmailTagsArr.length > 0) {
                            for(var index = 0;index<self.toEmailTagsArr.length;index++) {
                                if(!toEmailData.includes(self.toEmailTagsArr[index].text)) {
                                    toEmailData += (self.toEmailTagsArr[index].text) + ',';
                                }
                            }
                            toEmailData = toEmailData.replace(/,\s*$/, "");
                        }
                        var ccEmailData = "";
                        if(self.ccEmailTagsArr && self.ccEmailTagsArr.length > 0) {
                            for(var index = 0;index<self.ccEmailTagsArr.length;index++) {
                                if(!ccEmailData.includes(self.ccEmailTagsArr[index].text)) {
                                    ccEmailData += (self.ccEmailTagsArr[index].text) + ',';
                                }
                            }
                            ccEmailData = ccEmailData.replace(/,\s*$/, "");
                        }
                        var strLocationId = "";
                        if(self.location && self.location.length > 0) {
                            for(var index = 0; index < self.location.length; index++) {
                                var obj = self.location[index];
                                // if(!strLocationId.includes(obj['id'])) {
                                    strLocationId += obj['id'] + ",";
                                // }
                            }
                            strLocationId = strLocationId.replace(/,\s*$/, "");
                        }
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                        };
                        var fields = {
                            id: self.edit_id,
                            manager_email: self.managerEmail,
                            form_id: self.formId.value,
                            // departmentName: self.departmentId.value,
                            location: strLocationId,
                            to_email: toEmailData,
                            cc_email: ccEmailData,
                        };
                        self.showLoader();
                        HTTP.post("/form/mapper/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if (flag == 'save') {
                                        self.buttonBack();
                                    } else {                                        
                                        self.clearSaveAndContinue();
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            clearSaveAndContinue: function() {
                self.edit_id = 0;
                self.managerEmail = '';
                self.departmentId = '';
                self.location = [];
                self.formId = '';
                self.toEmail = '';
                self.ccEmail = '';
                self.toEmailTagsArr = [];
                self.ccEmailTagsArr = [];
                self.isLaborReviewRequest = false;
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            numberFormateValidation : function (inputtxt) {
                var valid = !/^\s*$/.test(inputtxt) && !isNaN(inputtxt);
                return valid;
            },
        }
    };
    EventBus.$on("permissions", function(isLogin, permissionArray) {
        if (typeof self != "undefined") {
            self.permissionsArray = [];
            if(permissionArray && permissionArray.length > 0) {
                for (var i = 0; i < permissionArray.length; i++) {
                    self.permissionsArray.push(permissionArray[i].name);
                }
            }
        }
    });
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Forms/FormEmailManager/AddUpdateFormEmailManager.vue